module.exports = __webpack_public_path__ + "img/RegFees-8-opening.bd10890c.svg";